// NavigationContext.tsx
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

interface NavigationStep {
    path: string; // Represents a navigation path like "Picking/Batch/Order"
    params?: { [key: string]: any }; // e.g., { documentNo: taco }
}

interface NavigationContextType {
    navigationPath: NavigationStep[];
    navigate: (step: NavigationStep) => void;
    goBack: () => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const history = useHistory();
    const location = useLocation();
    const [navigationPath, setNavigationPath] = useState<NavigationStep[]>([]);

    const buildUrl = (path: string, params?: { [key: string]: any }) => {

        const normalizedPath = path.startsWith("/") ? path : `/${path}`;


        const queryParams = params ? new URLSearchParams(params).toString() : "";
        const returnLink = `${normalizedPath}${queryParams ? `?${queryParams}` : ""}`;
        return returnLink;
    };




    // Navigate and update URL
    const navigate = (step: NavigationStep) => {
        //setNavigationPath(prev => {
        //    if (prev.length > 0) {
        //        const lastStep = prev[prev.length - 1];

        //        if (lastStep.path === step.path && JSON.stringify(lastStep.params) === JSON.stringify(step.params)) {
        //            return prev;
        //        }
        //    }

        //    return [...prev, step];
        //});
        history.push(buildUrl(step.path, step.params));
    };

    // Go back in navigation history
    const goBack = () => {
        setNavigationPath(prev => {

            const updatedPath = prev.slice(0, -1);

            if (updatedPath.length > 0) {
                const lastStep = updatedPath[updatedPath.length - 1];
                history.push(buildUrl(lastStep.path, lastStep.params));
            } else {
                history.push('/'); // Default to home when no steps remain
            }
            return updatedPath;
        });
    };
    useEffect(() => {
        const path = location.pathname.substring(1); // Remove leading "/"

        const searchParams = new URLSearchParams(location.search);
        const params: { [key: string]: any } = {};

        searchParams.forEach((value, key) => {
            params[key] = value;
        });

        setNavigationPath(prev => {
            if (prev.length > 0) {
                const lastStep = prev[prev.length - 1];

                // Skip adding if the last step has the same path and params

                if (lastStep.path === path && JSON.stringify(lastStep.params) === JSON.stringify(params)) {
                    return prev;
                }
            }

            return [...prev, { path, params }];
        });
    }, [location]);



    return (
        <NavigationContext.Provider value={{ navigationPath, navigate, goBack }}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigation = () => {
    const context = useContext(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
};